var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'guideline-edit',
  created () {
    this.search()
  },
  data () {
    return {
      canValidate: true,
      guideline: {
        guideline_content: null
      }
    }
  },
  computed: {
    guidelines () {
      return this.$store.getters.guideline
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    validation: function() {
      var v = {
        guideline_content: !!this.guidelines.data.attributes['guideline-content'],
        not_input: !!this.guidelines.data.attributes['guideline-content']
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    onClickSave: function () {
      this.canValidate = true
      if (this.isValid) {
        console.log("is valid")
        var data = {
          guideline_content: this.guidelines.data.attributes['guideline-content']
        }
        this.$store.dispatch('GUIDELINE_UPDATE', { id: this.$route.params.id, data: data, callback: this.onSaved })
      }else{
        console.log("need edit")
      }
    },
    onClickCancel: function () {
      this.$router.push({ path: '/guidelines', query: { type: this.$router.currentRoute.query.type}})
    },
    search: function() {
      var data = {}
      var self = this
      data.callback = function () {
      }
      this.$store.dispatch('GUIDELINE_EDIT',  {id: this.$route.params.id, data: data})
    },
    half: function () {
      this.guidelines.data.attributes['guideline-content'] = utils.emHalf(this.guidelines.data.attributes['guideline-content'])
    },
    onSaved: function (result) {
      this.$router.push({ path: '/guidelines/'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/guideline-edit.js